import angular from 'angular';

var module = angular.module('app.shared', []);

export default module;